import { FC } from "react";
import "./modalStyle.css";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { Modal } from "@mui/material";
interface IProps {
  handleClose: () => void;
  children: JSX.Element | JSX.Element[];
  open: boolean;
}
const FilterModal: FC<IProps> = ({ handleClose, children, open }) => {
  const { t } = useTranslation();
  const closeStyle = { color: "#133E5E", fontSize: "1.5em" };
  const modalStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  return (
    <>
      <Modal open={open} onClose={handleClose} style={modalStyle}>
        <div
          className="filter-centered"
          id="filter-modal"
          role="dialog"
          aria-modal="true"
          tabIndex={-1}
          aria-label="Filtres sur le jeu de données"
        >
          <div className="filter-modal">
            <div className="filter-modalHeader">
              <h5 className="filter-heading">{t("mobile_display_filter")}</h5>
              <button
                className="closeBtn"
                onClick={() => handleClose()}
                aria-label="Fermer la popup"
              >
                <AiOutlineCloseCircle style={closeStyle} />
              </button>
            </div>
            <div className="filter-modal-content">{children}</div>
            <div className="modalActions">
              <div className="actionsContainer">
                <button className="button-icon" onClick={() => handleClose()}>
                  <h4 className="underline-button-text">Annuler</h4>
                </button>
                <button
                  className="validate-button"
                  onClick={() => handleClose()}
                >
                  Valider
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default FilterModal;
